// src/components/atoms/ProgressBar/ProgressBar.tsx
import React from 'react';
import * as styles from './ProgressBar.css';

export interface ProgressBarProps {
  /** 0~100 사이 숫자 */
  progress: number;
  /** 높이 옵션: small | default | large */
  size?: 'small' | 'default' | 'large';
  /** 바 안쪽에 % 표시 여부 */
  showLabel?: boolean;
  /** 상단에 제목 표시 (없으면 숨김) */
  showTitle?: string;
  /** 컨테이너에 추가할 클래스 */
  containerClassName?: string;
  /** 헤더에 추가할 클래스 */
  headerClassName?: string;
  /** 라벨에 추가할 클래스 */
  labelClassName?: string;
  /** 제목에 추가할 클래스 */
  titleClassName?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  size = 'default',
  showLabel = true,
  showTitle,
  containerClassName,
  headerClassName,
  labelClassName,
  titleClassName,
}) => {
  const pct = Math.max(0, Math.min(100, progress));

  return (
    <div className={`${styles.progressContainer} ${containerClassName || ''}`}>
      {/* 상단 헤더 */}
      {(showTitle || showLabel) && (
        <div className={`${styles.header} ${headerClassName || ''}`}>
          {showTitle && (
            <p className={`${styles.title} ${titleClassName || ''}`}>{showTitle}</p>
          )}
          {showLabel && (
            <p className={`${styles.label} ${labelClassName || ''}`}>{`${pct}%`}</p>
          )}
        </div>
      )}

      {/* 프로그레스 바 */}
      <div className={styles.track}>
        <div
          className={`${styles.filler} ${styles.sizeVariants({ size })}`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
};